import { defineMessages } from 'react-intl';

export default defineMessages({
  info: {
    id: 'experienceSummary.info',
    defaultMessage: '{price} {guests}{groupSize} • {duration}{extraText}',
  },
  groupInfo: {
    id: 'experienceSummary.groupInfo',
    defaultMessage: 'Group discount available',
  },
  groupSizeInfo: {
    id: 'experienceSummary.groupSizeInfo',
    defaultMessage: ' • {size}',
  },
});
